import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {

  @Input() tag: string;
  @Input() link: string;

  public key;
  public branded = false;
  public brands = {
    "cnn": false,
    "economist": false,
    "espn": false,
    "wsj": false,
    "wapo": false,
    "yahoo": false,
    "nyt": false,
    "vox": false,
    "abc": false,
    "nationalreview": false,
    "nbc": false,
    "politico": false,
    "people": false,
    "guardian": false,
    "atlantic": false,
    "npr": false,
    "fox": false,
    "bbc": false,
    "cbs": false,
    "twitter": false
  }

  public textOnly = {
    "twitter": true
  }

  public alternates = {
    "nytimes": "nyt",
    "newyorktimes": "nyt",
    "washingtonpost": "wapo",
    "espnfc": "espn",
    "theguardian": "guardian",
    "theatlantic": "atlantic",
    "foxnews": "fox",
    "cbsnews": "cbs",
    "cbssports": "cbs"
  }

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.branded = false;
    for(let key of Object.keys(this.brands)) {
      this.brands[key] = false;
    }

    if(this.brands[this.tag] != undefined) {
      this.brands[this.tag] = true;
      this.branded = !this.textOnly[this.tag];
      this.key = this.tag;
    }

    else if(this.alternates[this.tag] != undefined){
      this.brands[this.alternates[this.tag]] = true;
      this.branded = !this.textOnly[this.tag];
      this.key = this.alternates[this.tag];
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/tag/tag.component.ts